// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />


export default class TestRect {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }
    private _rect?: vf.gui.Rect;
    private _rectPoint?: vf.gui.Rect;
    private _rect1?: vf.gui.Rect;
    private _buttonList: vf.gui.Label[] = [];

    private onRelease() {
        if (this._rect) {
            this._rect.removeAllListeners();
            this._rect.parent && this._rect.parent.removeChild(this._rect);
            this._rect.release();
            this._rect = undefined;
        }
        if (this._rectPoint) {
            this._rectPoint.removeAllListeners();
            this._rectPoint.parent && this._rectPoint.parent.removeChild(this._rectPoint);
            this._rectPoint.release();
            this._rectPoint = undefined;
        }
        if (this._rect1) {
            this._rect1.removeAllListeners();
            this._rect1.parent && this._rect1.parent.removeChild(this._rect1);
            this._rect1.release();
            this._rect1 = undefined;
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 绘制矩形 */
        const rect = this._rect = new vf.gui.Rect();
        rect.style.left = 100;
        rect.style.top = 100;
        rect.style.width = 10;
        rect.style.height = 10;
        rect.color = "#00ff00";
        rect.lineColor = "#ffffff";
        rect.lineWidth = 1;
        rect.radius = 10; //圆角
        rect.anchorX = 0.5;
        rect.anchorY = 0.5;
        uiStage.addChild(rect);


        //const p = "M60 171Q58 181 54 193Q26 255 16 277Q22 349 32 371Q10 457 66 477Q256 495 264 485Q214 371 178 315Q106 203 104 189Q118 117 122 107Q144 99 152 97Q264 151 300 189Q310 283 288 305Q220 321 198 309Q162 255 172 227Q284 193 358 199Q608 261 644 277Q662 379 642 411Q450 419 390 407Q336 353 328 301Q390 165 438 139Q602 123 656 141Q820 379 814 425Q670 489 604 491Q430 441 392 415Q366 317 380 271Q516 189 580 177Q712 221 740 257Q788 495 760 583Q634 677 584 679Q426 647 368 629Q100 485 80 457Q48 407 46 391Q94 311 136 291Q490 307 552 333Q626 433 614 531Q492 603 436 607Q216 519 148 475Q122 389 142 359Q322 287 368 279Q428 281 430 283Q446 299 450 301";
        // const p = "M60 171L300 221 L500 300";
        const p = "M100 301L300 221 L60 130";
        // const p = "M60 171C58 181,54 193,26 255";
        // const pa = new vf.gui.PathTimeline(p);
        // pa.loop = true;


        // pa.frames = [p1, p2];
        // const t = vf.gui.Utils.now();
        // vf.gui.TickerShared.add(() => {
        //     // pa.globalTime = vf.gui.Utils.now() - t;
        //     // rect.x = pa.curPos[0];
        //     // rect.y = pa.curPos[1];
        // });
        const pathSvg = new vf.gui.PathGraphics();
        pathSvg.path = p;
        pathSvg.lineType = "full";
        pathSvg.lineWidth = 5;
        pathSvg.lineColor = 0xffffff;
        pathSvg.beginPort = 1;
        pathSvg.endPort = 2;
        uiStage.addChild(pathSvg);


        const p1 = new vf.gui.NumberFrame();
        p1.time = 0;
        // p1.ease = vf.gui.Easing.Quartic.InOut;
        p1.value = 0;
        const p2 = new vf.gui.NumberFrame();
        p2.time = 30000;
        p2.value = 1;
        // const p3 = new vf.gui.NumberFrame();
        // p3.time = 10000;
        // p3.value = 1;
        // pa.totalTime = 30000;
        let path: any;
        this.getButton('播放', () => {
            path = vf.gui.Animation.play("path", rect, { frames: [p1, p2], loop: true, path: p }, -1, () => {
                console.log("播放完成");
            });

        }, uiStage, 15, 0);

        this.getButton('卸载', () => {
            path.release();

        }, uiStage, 15, 0);

    }



    private onClick(e: vf.gui.Interaction.InteractionEvent) {
        console.log(e.type);
    }


    private posY = 15;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 30;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 30 + y;
        this._buttonList.push(button);
        return button;
    }

}

